import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=1a7e99ae&scoped=true"
import script from "./wel.vue?vue&type=script&lang=js"
export * from "./wel.vue?vue&type=script&lang=js"
import style0 from "./wel.vue?vue&type=style&index=0&id=1a7e99ae&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e99ae",
  null
  
)

export default component.exports